import { ITokenApplyOrgCfg, tokenApplyOrg } from '~packages/esia-auth-boundary';

import hosts from '@/api/configs/hosts.json';
import modulesHostsMap from '@/api/configs/modules.hostsMap.json';

export const baseGet = () => {
  const moduleHost = modulesHostsMap.esia;
  return hosts[moduleHost.name as keyof typeof hosts] + moduleHost.path;
};

/**
 *
 * @param cfg
 * @returns
 */
const fn = async (cfg: Omit<ITokenApplyOrgCfg, 'base'>) => {
  return tokenApplyOrg({ ...cfg, base: baseGet() });
};

export default fn;
